import type { PresentationPdfInput } from "./downloadPresentationPdf";

export function triggerPresentationPdfDownload(input: PresentationPdfInput): void {
  void import("./downloadPresentationPdf").then((mod) => {
    mod.downloadPresentationPdf(input);
  });
}
